import { Button } from "@shopify/polaris";
import { useCallback } from "react";
const ResourcePickerButton = ({
  resourceType,
  onSelection,
  primary,
  disabled,
  selectMultiple = true,
  isLoading,
  plain,
  title,
  initialSelectionIds
}) => {
  const handleOpen = useCallback(async () => {
    const selected = await shopify.resourcePicker({
      type: resourceType.toLowerCase(),
      action: "select",
      multiple: selectMultiple,
      filter: { variants: false },
      selectionIds: initialSelectionIds
    });

    // `undefined` means the picker was cancelled
    if (selected) {
      onSelection(selected);
    }
  }, [resourceType, selectMultiple, initialSelectionIds, onSelection]);

  return (
    <Button
      disabled={disabled}
      primary={primary}
      loading={isLoading}
      onClick={handleOpen}
      plain={plain}
    >
      {title ? title : `Add ${resourceType}s`}
    </Button>
  );
};

export default ResourcePickerButton;